/*	Lyle F. Chamarette
	STEP Networks Inc (c) 20th June 2018	
	London, Ontario Weather
	Updated on Wed Jun 20 3:45 PM
	19°C FEELS LIKE	23
	Light rain showers
	
	LMIT-524
*/	

window.l10n = {};
window.l10n.locale = {};
window.l10n.EN = {
	"application.title" : "Insurance ONFILE",

	"landing.insurance" : "INSURANCE",
	"landing.onfile" : "ONFILE",
	"landing.faqs" : "FAQS",
	"landing.privacypolicy" : "PRIVACY POLICY",
	"landing.contactus" : "CONTACT US",
	"landing.logout"	: "LOGOUT",
	"landing.yourlease" : "YOUR LEASE ",
	"landing.documentcentre" : "DOCUMENT CENTRE",
	"landing.lastname" : "LAST NAME",
	"landing.postalcode" : "POSTAL CODE",
	"landing.welcome" : "WELCOME",
	"landing.caption2" : "Securely upload documents so that the insurance on file for your leased vehicle is up to date and in compliance with your lease agreement.",
	"landing.updatedocuments" : "UPDATE YOUR DOCUMENTS",
	"landing.secureweb" : "SECURE WEB APPLICATION",
	"landing.easeofuse" : "EASE OF USE",
	"landing.caption3" : "Once logged in you can upload a scan or picture of your policy documents securely",
	"landing.caption4" : "Protecting personal information is a priority. This website allows for the secure transfer of personal information",
	"landing.caption5" : "In just a few clicks you can update the information on your account so that it is in compliance with your lease agreement",
	"landing.mobileversion" : "Mobile Version",
	"landing.desktopversion": "Desktop Version",
	"landing.language" : "FR",
	"landing.languagefull" : "FRANÇAIS",
	"landing.copyright" : "Copyright © 2018, LMITS",

	/*"welcome.message"	: "ScheduledOutageTitle#ScheduledOutageMessage",*/

	"login.caption1" : "Please use your VIN and lease account number to login. You can find your lease account number on your lease agreement or on other notifications you may have received.",
	"login.logintoyouraccount" : "LOGIN TO YOUR ACCOUNT",
	"login.vinno" : "VIN NO",
	"login.accountnumber" : "ACCOUNT NUMBER",
	"login.signin" : "SIGN IN",
	"login.fail.line1" : "After 5 unsuccessful login attempts your account will be temporarily locked.  Please use the Contact Us link if you have any questions.",	
	"login.unscheduled.message" : "<p>The system is presently unavailable.<p><p>Please try again later.",

	"adminlogin.username" : "USERNAME",
	"adminlogin.password" : "PASSWORD",

	"lessee.welcome" : "WELCOME",
	"lessee.caption1" : "Insurance coverage for your leased vehicle must comply with the Lease Agreement requirements.",
	"lessee.caption2" : " Please review the information in the highlighted areas below.",
	"lessee.carrier" : "Carrier",
	"lessee.policynumber" : "Policy No.",
	"lessee.leaseaccountnumber" : "Lease Account Number",
	"lessee.vehicledescription" : "Vehicle Description",
	"lessee.vinnumber" : "VIN Number",
	"lessee.requirements" : "Requirements as per your lease agreement",
	"lessee.requirements1" : "If the coverage doesn’t meet the requirements, please contact your insurance provider to revise the policy",
	"lessee.pleaseupload" : "Please upload your insurance policy to confirm coverage. Pictures are accepted.",
	"lessee.caption3" : "If you have more than one policy covering this vehicle please ensure that you send us copies of all documents.",
	"lessee.msgok" : "Your insurance on file is up to date and adequate. Please remember to return again to upload a copy of your inforce policy whenever there is a change or renewal. Thank you.",
	"lessee.msg-no-policy" : "No insurance information is on file for this account.  Please upload a copy of your inforce policy so that your account can be updated.  Thank you.",
	"lessee.uploadfiles" : "Upload files",
	"lessee.currentcoverage" : "Current Coverage Details",
	"lessee.policyexpires" : "Expiration Date",
	"lessee.comprehensiveded" : "Comprehensive Deductible",
	"lessee.thirdparty" : "Third Party Liability",
	"lessee.permissiontorent" : "Endorsement # 5, Permission to Rent or Lease",
	"lessee.allperils" : "All Perils",
	"lessee.additionalinsured" : "Listed as Additional Insured",
	"lessee.collisionded" : "Collision Deductible",
	"lessee.policycancelled" : "Policy is not Cancelled",
	"lessee.losspayee" : "Listed as Loss Payee",
	"lessee.adequate"	: "Adequate Insurance",
	"lessee.monthnames" : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],

	"upload.uploadyourdoc" : "Upload your documents",
	"upload.or" : "or",
	"upload.draganddrop"	: "Drag and drop files here",
	"upload.browsefiles"	: "Browse files",
	"upload.upload-success"	: "Thank you for your upload. Your account will be updated within 24 hours.",
	"upload.upload-failure"	: "An X indicates an unsuccessful upload.  If you see an X please try again, or click on the contact us link for assistance.",

	"contactus.firstname"	: "First name",
	"contactus.lastname"	: "Last name",
	"contactus.phonenumber"	: "Your phone number",
	"contactus.email"		: "Your email address",
	"contactus.manufacturer": "Manufacturer",
	"contactus.vin" 		: "Vin Number",
	"contactus.msg"			: "Message",
	"contactus.submit"		: "Submit",
	"contactus.getintouch"	: "Get in Touch",
	"contactus.fillout"	: "Fill out this form and we will be in touch in lightning speed.",
	"contactus.title"	: "Thank you for Contacting Us",
	"contactus.text"	: "This is to confirm we have received your inquiry and will get back to you within 24 to 48 hours.",
	"contactus.errormsg": "There was an error sending the message",


	"faq.question1" : "How do I find my lease account number?",
	"faq.answer1"   : "Your lease account number can be found on your lease agreement or on other notifications regarding your lease that you may have received.",
	"faq.question2" : "How do I find my VIN?",
    "faq.answer2"   : "Your VIN is the 17-digit alphanumeric unique identifier for your vehicle.  You can find it on your lease agreement, insurance policy documents or on the windshield of the vehicle.",
	"faq.question3" : "Why am I being asked to provide a copy of my policy?",
    "faq.answer3"   : "As part of your lease agreement, you are required to obtain and maintain a certain minimum insurance coverage.   You are being asked to provide a copy of your policy because the insurance on file for your vehicle does not meet the requirements set out by your lease agreement.",
	"faq.question4" : "What is www.insuranceonfile.com ?",
    "faq.answer4"	: "Insuranceonfile.com is a website that allows you to securely upload copies of your policy documents so that leasing companies can be made aware that the insurance on your leased vehicle is up to date and meets the minimum requirements.",
	"faq.question5" : "How is my personal information protected?",
    "faq.answer5"	: "The protection of your personal information is a matter of high priority.  Any personal information provided when using insuranceonfile.com is subject to the privacy policy which can be found on the home page.",
    "faq.question6" : "How do I know if my account has been updated?",
	"faq.answer6"	: "After you have successfully uploaded your policy documents, your account will be updated within 24 hours.  After that time, you can login again and you will see a confirmation message stating that your insurance on file is adequate.  If you do not see this message, you can contact us for assistance.",
}

window.l10n.FR = {
	"application.title" : "ASSURANCE AU DOSSIER",

	"landing.insurance" : "ASSURANCE",
	"landing.onfile" : "AU DOSSIER",
	"landing.faqs" : "FAQ",
	"landing.privacypolicy" : "POLITIQUE SUR LA CONFIDENTIALITÉ",
	"landing.contactus" : "CONTACTEZ-NOUS",
	"landing.logout"	: "DÉCONNEXION",
	"landing.yourlease" : "CENTRE DE ",
	"landing.documentcentre" : "TRAITEMENT DES CONTRAT DE LOCATION",
	"landing.postalcode" : "CODE POSTAL",
	"landing.welcome" : "BIENVENUE",
	"landing.caption2" : "Téléversez les documents en toute sécurité afin que la couverture d'assurance au dossier pour votre véhicule loué soit à jour et en conformité avec votre contrat de location.",
	"landing.updatedocuments" : "METTEZ VOS DOCUMENTS À JOUR",
	"landing.secureweb" : "APPLICATION WEB SÉCURISÉE",
	"landing.easeofuse" : "FACILITÉ D'UTILISATION",
	"landing.caption3" : "Une fois connecté, vous pouvez téléverser une copie numérisée ou une photo de vos documents de police en toute sécurité",
	"landing.caption4" : "La protection des renseignements personnels est une priorité. Ce site Web permet le transfert sécurisé de renseignements personnels",
	"landing.caption5" : "En quelques clics seulement, vous pouvez mettre à jour les renseignements sur votre compte afin qu'ils soient en conformité avec votre contrat de location",
	"landing.mobileversion" : "Version mobile",
	"landing.desktopversion" : "Version de bureau",
	"landing.language" : "EN",
	"landing.languagefull" : "ENGLISH",
	"landing.copyright" : "Copyright © 2018, LMITS",
	
	/*"welcome.message"	: "ScheduledOutageTitle#ScheduledOutageMessage",*/
	
	"login.caption1" : "Veuillez utiliser votre NIV et numéro de compte pour vous connecter. Vous trouverez votre numéro de compte sur votre contrat de location ou sur d'autres avis que vous avez reçus.",
	"login.logintoyouraccount" : "CONNEXION À VOTRE COMPTE",
	"login.vinno" : "NIV",
	"login.accountnumber" : "NUMÉRO DE COMPTE",
	"login.signin" : "CONNECTEZ-VOUS",
	"login.fail.line1" : "Après 5 tentatives de connexion infructueuses, votre compte sera temporairement verrouillé.  Veuillez utiliser le lien Contactez-nous si vous avez des questions.",
	"login.unscheduled.message" : "<p>Le système n’est actuellement pas disponible.</p><p/><p>Veuillez réessayer plus tard.</p>",
	
	"adminlogin.username" : "nom d'utilisateur",
	"adminlogin.password" : "un mot de passe",	

	"lessee.welcome" : "BIENVENUE",
	"lessee.caption1" : "La couverture d'assurance pour votre véhicule loué doit être en conformité avec les exigences du contrat de location.",
	"lessee.caption2" : " Veuillez examiner les renseignements dans les sections en surbrillance ci-dessous.",
	"lessee.carrier" : "Carrier",
	"lessee.policynumber" : "Numéro de police",
	"lessee.leaseaccountnumber" : "numéro de compte",
	"lessee.vehicledescription" : "Description du véhicule",
	"lessee.vinnumber" : "NIV",
	"lessee.requirements" : "Exigences conformément à votre contrat de location",
	"lessee.requirements1" : "Si la couverture ne répond pas aux exigences, veuillez communiquer avec votre assureur pour réviser la police",
	"lessee.pleaseupload" : "Veuillez téléverser votre police d'assurance pour confirmer la couverture. Les photos sont acceptées.",
	"lessee.caption3" : "Si vous avez plus d'une police pour couvrir ce véhicule, veuillez vous assurer de nous envoyer des copies de tous les documents.",
	"lessee.msgok" : "Votre police d'assurance au dossier est à jour et suffisante. N'oubliez pas d'y retourner pour téléverser une copie de votre police en vigueur lors d'un changement ou du renouvellement. Merci.",
	"lessee.msg-no-policy" : "Aucune information d'assurance n'est au dossier pour ce compte. Veuillez télécharger une copie de votre politique en vigueur afin que votre compte puisse être mis à jour. Je vous remercie.",
	"lessee.uploadfiles" : "Téléverser les fichiers",
	"lessee.currentcoverage" : "Détails de la couverture actuelle ",
	"lessee.policyexpires" : "Expiration ou renouvellement de la police",
	"lessee.comprehensiveded" : "Franchise pour garantie sans collision ni versement",
	"lessee.thirdparty" : "Responsabilité civile",
	"lessee.permissiontorent" : "Avenant automobiles louées",
	"lessee.allperils" : "Tous risques",
	"lessee.additionalinsured" : "assuré supplémentaire",
	"lessee.collisionded" : "Franchise collision",
	"lessee.vehicleremoved" : "Véhicule retiré/Pas de couverture en vigueur",
	"lessee.policycancelled" : "La police n’est pas annulée",
	"lessee.losspayee" : "bénéficiaire",
	"lessee.endorsmentname" : "Nom de l'avenant",
	"lessee.adequate"	: "Assurance adéquate",
	"lessee.monthnames" : ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],

	"upload.uploadyourdoc" : "Téléverserz vos documents",
	"upload.draganddrop" : "Glissez et déposez les fichiers ici",
	"upload.browsefiles" : "Parcourez les fichiers",
	"upload.or" : "ou",
	"upload.upload-success"	: "Une coche indique un téléversement réussi. Merci de votre téléversement. Votre compte sera mis à jour dans les 24 heures.",
	"upload.upload-failure"	: "Un X indique un échec du téléversement. Si vous voyez un X, veuillez réessayer ou cliquer sur le lien contactez-nous pour obtenir de l'aide.",

	"contactus.firstname"	: "Prénom",
	"contactus.lastname"	: "Nom de famille",
	"contactus.phonenumber"	: "Votre numéro de téléphone",
	"contactus.email"		: "Votre adresse courriel",
	"contactus.manufacturer": "Fabricant",
	"contactus.vin" 		: "NIV",
	"contactus.msg"			: "Message",
	"contactus.submit"		: "Soumettre",
	"contactus.getintouch"	: "Prendre contact",
	"contactus.fillout"	: "Remplissez ce formulaire et nous vous répondrons très rapidement",
	"contactus.title"	: "Merci de nous contacter",
	"contactus.text"	: "Ceci est pour confirmer que nous avons reçu votre demande et que nous vous répondrons dans 24 à 48 heures",
	"contactus.errormsg": "Une erreur s'est produite lors de l'envoi de ce message",


	"faq.question1" : "Comment faire pour trouver le numéro de compte de mon contrat de crédit-bail ?",
	"faq.answer1"   : "Le numéro de compte de votre contrat de crédit-bail se trouve sur votre contrat ou sur d'autres avis que vous auriez reçus concernant ce dernier. ",
	"faq.question2" : "Comment trouver le numéro d’identification (VIN) de mon véhicule ?",
    "faq.answer2"   : "Le numéro d’identification (VIN) de votre véhicule est un identifiant unique de 17 caractères alphanumériques.  Vous pouvez le trouver sur votre contrat de crédit-bail, sur les documents relatifs à votre police d’assurance ou sur le pare-brise du véhicule.",
    "faq.question3" : "Pourquoi me demande-t-on de fournir un exemplaire de ma police ?",
    "faq.answer3"   : "Dans le cadre de votre contrat de crédit-bail, vous devez obtenir et maintenir une couverture minimale des garanties fournies. On vous demande un exemplaire de votre police parce que l’assurance au dossier de votre véhicule ne répond pas aux exigences fixées par votre contrat de crédit-bail.",
    "faq.question4" : "Qu’est-ce que le site www.insuranceonfile.com ?",
    "faq.answer4"	: "Insuranceonfile.com est un site qui vous permet de téléverser en toute sécurité des copies de vos documents d’assurance pour que les sociétés de crédit-bail puissent être avisées du fait que l’assurance sur votre véhicule est à jour et répond aux exigences minimales. ",
    "faq.question5" : "Comment mes renseignements personnels sont-ils protégés ?",
    "faq.answer5"	: "La protection de vos renseignements personnels est une question de haute priorité.  Tous les renseignements personnels fournis dans le cadre de l’utilisation du site insuranceonfile.com sont soumis à la politique de confidentialité disponible dans la page d’accueil.",
    "faq.question6" : "Comment savoir si mon compte a été mis à jour ?",
    "faq.answer6"	: "Une fois que vous avez téléversé avec succès vos documents d’assurance, votre compte sera mis à jour dans les 24 heures.  Après ce délai, vous pouvez vous connecter à nouveau et vous verrez un message de confirmation indiquant que votre assurance au dossier est adéquate.  Si vous ne voyez pas ce message, vous pouvez communiquer avec nous pour obtenir de l’aide. ",
}


// WEBPACK FOOTER //
// ./src/config.js